import PropTypes from 'prop-types'
import { createContext, useReducer } from 'react'

import { topOffersReducer, initialState } from './topOffersReducer'

const TopOffersContext = createContext()

function TopOffersProvider(props) {
  const { children } = props
  const state = useReducer(topOffersReducer, initialState)

  return <TopOffersContext.Provider value={state}>{children}</TopOffersContext.Provider>
}

TopOffersProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { TopOffersContext, TopOffersProvider }
